import HttpCLient from '@/lib/utils/httpClient';

type Store = {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
};

export type ProductItem = {
  integrationId: string;
  arabicName?: string;
  englishName?: string;
  arabicDescription?: string;
  englishDescription?: string;
  price?: number;
  originalPrice?: number;
  isSoldOut?: boolean;
  returnable?: boolean;
  defaultImage?: string;
  isHaveValidDiscount?: boolean;
  branchId?: string;
  storeName?: string;
  branchName?: string;
  storeId?: string;
};

class SerchDialog extends HttpCLient {
  fetchProducts = async (keyword: string) => {
    if (keyword?.length <= 0) return [];

    const data = {
      searchKeyWord: keyword,
    };

    const response = await this.post<ProductItem[]>('catalog/menu/search', {
      ...data,
    });

    return response;
  };

  fetchStores = async (q: string = '', page: string = '1', pageCount: string = '100') => {
    const data = {
      q: q,
      page: page,
      pageCount: pageCount,
    };

    return this.get<Store[]>('core/branches/nearby', data);
  };
}

export const searchService = new SerchDialog();
